import { render, staticRenderFns } from "./ListInstitutions.vue?vue&type=template&id=fcf7d7d6&"
import script from "./ListInstitutions.vue?vue&type=script&lang=js&"
export * from "./ListInstitutions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcf7d7d6')) {
      api.createRecord('fcf7d7d6', component.options)
    } else {
      api.reload('fcf7d7d6', component.options)
    }
    module.hot.accept("./ListInstitutions.vue?vue&type=template&id=fcf7d7d6&", function () {
      api.rerender('fcf7d7d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/lists/components/ListInstitutions.vue"
export default component.exports